<template>
  <mdb-row>
    <mdb-col md="6">
      <mdb-select
        search
        @getValue="getSelectValue"
        v-if="loadReady"
        v-model="labelOptions"
        :visibleOptions="6"
        :label="$t('retailerchain')"
        :placeholder="$t('choose_retailerchain')"
      />
    </mdb-col>
    <mdb-col md="6">
      <RetailerChainMemberSelection
        :retailer-chain-id="retailerChainId"
        :retailer-id="retailerId"
        v-if="loadReady && memberVisibility"
        v-on:member="member"
      />
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbSelect, mdbCol, mdbRow } from "mdbvue";
import RetailerChainMemberSelection from "@/components/RetailerChainMemberSelection.vue";

export default {
  name: "RetailerChainSelection",
  components: {
    mdbSelect,
    mdbCol,
    mdbRow,
    RetailerChainMemberSelection,
  },
  props: {
    content: Object,
    memberVisibility: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    loadReady: false,
    retailerChainId: 0,
    retailerId: 0,
    retailerChains: [],
    labelOptions: [],
    retailerchainspath: "/1.0/front/retailers/chains",
  }),
  methods: {
    getRetailerChainDescription(id) {
      var retailerChain = this.retailerChains.find(
        (retailerChain) => retailerChain.id === id
      );
      return retailerChain.description;
    },
    checkContent() {
      this.labelOptions = [];
      var defaultSelection = (this.retailerChainId = this.retailerChains[0].id);
      if (this.content != null) {
        defaultSelection = this.retailerChainId = this.content.retailerchain.id;
        if (this.content.hasOwnProperty("retailer_id"))
          this.retailerId = this.content.retailer_id;
      }
      this.retailerChains.forEach(function (retailerChain) {
        this.labelOptions.push({
          text: retailerChain.name + ", id:" + retailerChain.id,
          value: retailerChain.id,
          selected: defaultSelection === retailerChain.id ? true : false,
        });
      }, this);
    },
    member(member) {
      this.$emit(
        "member",
        member,
        this.retailerChainId,
        this.getRetailerChainDescription(this.retailerChainId)
      );
    },
    getSelectValue(val) {
      this.retailerChainId = val;
      this.$emit("retailerchainid", val);
    },
  },
  watch: {
    content: function (newVal, oldVal) {
      if (newVal !== null) {
        this.checkContent();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  mounted() {
    this.$http
      .get(this.retailerchainspath)
      .then((response) => {
        if (response.status == 200) {
          this.retailerChains = response.data.retailerchains;
          this.checkContent();
          this.getSelectValue(
            this.content != null
              ? this.content.retailerchain.id
              : response.data.retailerchains[0].id
          );
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>

<style>
.form-control {
  color: #495057;
}
</style>
